export const DocumentFilePathConstants = {
  MEDICAL_CONSENT_FORM:
    "https://documents.booster.co.nz/boosterdocuments/Insurance/Current/Forms/Booster Assurance_Medical Records Consent Form_Jan 2025.pdf",
};
